import { useMemo } from 'react';
import { usePartners } from './partner';
import { useStores } from './store-selection/queries/useStores';
import { useQueryParams } from './useQueryParams';
import { useType } from './useType';

export const usePartner = () => {
    const { storeId } = useQueryParams();
    const stores = useStores();
    const type = useType();
    const { partners } = usePartners(type);

    return useMemo(() => {
        if (storeId === undefined || storeId === 'overview') return undefined;
        const store = stores?.data.allStores.find((store) => store.id === Number(storeId));
        if (!store) return undefined;
        const partnerId = store.operationalResponsible?.id;
        return partners?.find((p) => p.id === partnerId);
    }, [storeId, stores, partners]);
};
